import theme from '@wavetrak/theme';

const Triangle = ({ fill }: { fill: string }) => (
  <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25192 4.66795C8.84566 5.06377 8.84566 5.93623 8.25192 6.33205L2.0547 10.4635C1.39015 10.9066 0.5 10.4302 0.5 9.63148V1.36852C0.5 0.569822 1.39015 0.0934302 2.0547 0.536467L8.25192 4.66795Z"
      fill={fill || theme.palette.text.base}
    />
  </svg>
);

export default Triangle;
